import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { getToken } from "../../Utils/Auth/Token";
import { URL } from "./url";
import Swal from "sweetalert2";
import { navigate } from "../../navigationService";
let token = getToken();
let Api: AxiosInstance = axios.create({
  baseURL: URL.API_BASE_URL,
  headers: {
    token: token ? token : "",
  },
});
Api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error?.response?.status === 401) {
      Swal.fire({
        title: "Session Expired",
        text: "Please login to continue",
        icon: "info",
        confirmButtonColor: "#FBB415",
      }).then((result: any) => {
        if (result.isConfirmed) {
          localStorage.clear();
          // navigate("/login");
          window.location.href = "/login";
        }
      });
    }
    return Promise.reject(error);
  }
);
export default Api;
